import { PRESUPUESTADOR_ENDPOINT } from 'cfgCommon/endpoints'
import axios from 'axios'

export async function getAlertsUltimoPresupuestoEditado(body) {
  const response = await axios.put(`${PRESUPUESTADOR_ENDPOINT}/alerts`, body)
  return response.data.data
}
